import { Webhooks as Component } from "../../../../components/Webhooks";

export default () => {
  return {
    Component
  }
};
